import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';

// constants
import appRoutes from '../../../../app-routes';
import { RECIPIENT_STATUSES } from '../../../../constraints';

// Components
import { CopiedInfo } from '../../../../components';
import * as Styled from './styled';
import { Grid, Utils } from 'billon-ui';

const { Row, Col } = Grid;
const { Button: ButtonModule } = Utils;
const { Button } = ButtonModule;

const RecipientTableDetails = ({ record }) => {
  const history = useHistory();

  const handleShowDetails = () => {
    history.push(appRoutes.RECIPTIENT_DETAILS.replace(':id', record.id));
  };
  const isDisabled = record.isGdprSuspended;

  if (isDisabled) {
    return (
      <Styled.NoDataLabel>
        <FormattedMessage
          id="Data processing suspended"
          defaultMessage="Data processing suspended"
        />
      </Styled.NoDataLabel>
    );
  }

  return (
    <Row noGutters margin={0} lg={12}>
      <Styled.CopiedInfoColumn lg={6}>
        <CopiedInfo
          label="Internal ID"
          value={record.id}
          emphasisedValue
          valuePlacedBetween
        />
      </Styled.CopiedInfoColumn>
      <Col lg={6}>
        <Styled.FlexEndRow lg={12}>
          <Styled.ActionButtonColumn md={4}>
            <Button
              outline
              onClick={handleShowDetails}
              block
              disabled={record?.status === RECIPIENT_STATUSES.FORGETTING}
            >
              <FormattedMessage id="See details" defaultMessage="See details" />
            </Button>
          </Styled.ActionButtonColumn>
        </Styled.FlexEndRow>
      </Col>
    </Row>
  );
};

export default RecipientTableDetails;
